// extracted by mini-css-extract-plugin
export default {"right":"rightContainer_right__jTzV+","links":"rightContainer_links__2MoNt"};